// libraries
import { CustomerVehiclesList } from '@makemydeal/dr-activities-customer-vehicles';

// hooks
import { useCustomerVehiclesSlideout } from '../hooks';

const CustomerVehiclesSlideout = () => {
    const { handleClose } = useCustomerVehiclesSlideout();

    return <CustomerVehiclesList onClose={handleClose} showOpenDealCTA={true} />;
};

export default CustomerVehiclesSlideout;
